export const getTitleFromUrl = (url: string) => {
  return new URL(url).pathname.split('/').at(-1);
};
